export default "__VITE_ASSET__CcnLgRRR__"